import Big from 'big.js'

/**
 * Converts an amount from cents to dollars.
 * @param {number} cents - The value in cents to be converted.
 * @returns {number} The value in dollars.
 */
export const convertCentsToDollars = (cents: number) => Math.round(cents) / 100

/**
 * Converts an amount from dollars to cents.
 * @param {number} dollars - The value in dollars to be converted.
 * @returns {number} The value in cents.
 */
export const convertDollarsToCents = (dollars: number): number => {
	if (isNaN(dollars)) return dollars
	const cents = dollars * 100
	return cents
}

/**
 * Converts a user-entered dollar amount to whole cents, rounding down.
 * @param {string} dollars - The value in dollars, e.g. '1,234.56'. Blank or unparseable input yields null.
 * @returns {number | null} The value in cents, or null when nothing valid was entered.
 */
export const convertDollarStringToCents = (dollars: string): number | null => {
	const normalized = dollars.replace(/[$,\s]/g, '')
	if (!normalized) return null
	try {
		return parseInt(new Big(normalized).times(100).toFixed(0, 0), 10) // 0 means ROUND_DOWN
	} catch {
		return null
	}
}

/**
 * Converts an amount in cents to a plain dollar string, for prefilling amount inputs.
 * @param {number} cents - The value in cents to be converted.
 * @returns {string} The value in dollars with two decimals, without currency symbol or separators.
 */
export const convertCentsToDollarString = (cents: number): string =>
	new Big(cents).div(100).toFixed(2)
